import PageTitle from "../hooks/PageTitle"
import PageHeader from "../layouts/PageHeader"

const Education = () => {
  return (
    <>
        <PageTitle title="Education"/>
        <PageHeader headerTitle="Education"/>
        <div className="w-75 mx-auto" data-aos="fade-up">
        <div className="degree">
            <h5>Master in Information Technology</h5>
            <small>Jahangirnagar University, 2023</small>
            <hr/>
          </div>
          <div className="degree">
            <h5>PGD in Information Technology</h5>
            <small>Jahangirnagar University, 2022</small>
            <hr/>
          </div>
          <div className="degree">
            <h5>Management Information Systems</h5>
            <small>Khwaja Yunus Ali University, 2019</small>
            <hr/>
          </div>
        </div>
    </>
  )
}

export default Education